module.exports = __webpack_public_path__ + "static/process-page-header-1418b0fd4da8fac9dcfc8fc890ccc593.png";